// extracted by mini-css-extract-plugin
export var headerCell = "_57-1";
export var loadingStateCell = "_57-4";
export var rowWrapper = "_57-3";
export var standaloneTable = "_57-5";
export var table = "_57-0";
export var white = "_57-2";